import { render, staticRenderFns } from "./MergeForm.vue?vue&type=template&id=45727949&scoped=true"
import script from "./MergeForm.vue?vue&type=script&lang=js"
export * from "./MergeForm.vue?vue&type=script&lang=js"
import style0 from "./MergeForm.vue?vue&type=style&index=0&id=45727949&prod&lang=scss&scoped=true"
import style1 from "./MergeForm.vue?vue&type=style&index=1&id=45727949&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45727949",
  null
  
)

export default component.exports